import { useContext } from 'react';

import { ConfigContext } from '#src/contexts/config/index.ts';
import { CurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { isJonumExempt } from '#src/lib/jonum.ts';

const AFFECTED_COUNTRY = ['FR'];

export const useApplyJonumRestriction = () => {
  const currentUser = useContext(CurrentUserContext)?.currentUser;
  const countryCode = useContext(ConfigContext)?.currentLocation.countryCode;

  const isInAffectedCountry =
    !!countryCode && AFFECTED_COUNTRY.includes(countryCode.toUpperCase());
  const jonumVerification = currentUser?.jonumVerification;

  if (!jonumVerification) {
    return isInAffectedCountry;
  }

  return !isJonumExempt(jonumVerification.status, isInAffectedCountry);
};
